import React, { useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import tr from 'date-fns/locale/tr';
import 'react-datepicker/dist/react-datepicker.css';
import './DateAndTimeSelectStep.css';
import { fetchAppointmentAvailability } from '../services/serviceRecordsService';

registerLocale('tr', tr);

const FALLBACK_SLOTS = [
  { kod: 'sabah', label: 'Sabah', aralik: '09:00-12:00', baslangic: '09:00', maxKapasite: 10, tip: 'normal' },
  { kod: 'ogle', label: 'Öğle', aralik: '12:00-15:00', baslangic: '12:00', maxKapasite: 10, tip: 'normal' },
  { kod: 'aksamustu', label: 'Akşamüstü', aralik: '15:00-18:00', baslangic: '15:00', maxKapasite: 10, tip: 'normal' },
  { kod: 'aksam', label: 'Akşam', aralik: '18:00-21:00', baslangic: '18:00', maxKapasite: 10, tip: 'normal' },
  { kod: 'ilave', label: 'İlave', aralik: '09:00-21:00', baslangic: '09:00', maxKapasite: 5, tip: 'ilave' },
];

const DateAndTimeSelectStep = ({
  selectedDate,
  setSelectedDate,
  selectedTime,
  setSelectedTime,
  selectedSlotKodu,
  setSelectedSlotKodu,
  teknikServisId,
}) => {
  const [slots, setSlots] = useState(FALLBACK_SLOTS);
  const [loadingSlots, setLoadingSlots] = useState(false);

  const handleDateChange = (date) => {
    if (date) {
      setSelectedDate(date);
      setSelectedTime(null);
      setSelectedSlotKodu?.(null);
    } else {
      setSelectedDate(null);
      setSelectedTime(null);
      setSelectedSlotKodu?.(null);
    }
  };

  useEffect(() => {
    if (!selectedDate || !teknikServisId) {
      setSlots(FALLBACK_SLOTS);
      return;
    }
    const y = selectedDate.getFullYear();
    const m = String(selectedDate.getMonth() + 1).padStart(2, '0');
    const d = String(selectedDate.getDate()).padStart(2, '0');
    const tarih = `${y}-${m}-${d}`;
    let cancelled = false;
    setLoadingSlots(true);
    fetchAppointmentAvailability(tarih, teknikServisId)
      .then((res) => {
        if (cancelled) return;
        const list = res?.veri?.araliklar || res?.veri?.saatler || FALLBACK_SLOTS;
        setSlots(list.length ? list : FALLBACK_SLOTS);
      })
      .catch(() => {
        if (!cancelled) setSlots(FALLBACK_SLOTS);
      })
      .finally(() => {
        if (!cancelled) setLoadingSlots(false);
      });
    return () => {
      cancelled = true;
    };
  }, [selectedDate, teknikServisId]);

  const handleSlotSelect = (slot) => {
    if (slot.secilebilir === false) return;
    setSelectedTime(slot.baslangic);
    setSelectedSlotKodu?.(slot.kod);
  };

  return (
    <div className="date-time-select-step">
      <div className="step-title-modern">
        <div className="step-title-icon">
          <i className="fas fa-calendar-alt"></i>
        </div>
        <div className="step-title-content">
          <h3>Tarih ve Saat Seçimi</h3>
          <p>Randevu tarihini ve saat aralığını belirleyin</p>
        </div>
      </div>

      <div
        className="calendar-section"
        style={{
          background: 'white',
          border: '2px solid #e2e8f0',
          borderRadius: '12px',
          padding: '20px',
          marginBottom: '24px',
        }}
      >
        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          inline
          locale="tr"
          minDate={new Date()}
        />
      </div>

      {selectedDate ? (
        <div className="time-slots-section">
          <h4 style={{ marginBottom: 12, fontSize: 15, fontWeight: 600 }}>Saat aralığı</h4>
          {loadingSlots ? (
            <p style={{ color: '#64748b' }}>Yükleniyor…</p>
          ) : (
            <div className="time-slots-grid">
              {slots.map((slot) => {
                const active = selectedSlotKodu
                  ? selectedSlotKodu === slot.kod
                  : selectedTime === slot.baslangic;
                const disabled = slot.secilebilir === false;
                const count = slot.toplamRandevu ?? 0;
                const max = slot.maxKapasite ?? 10;
                return (
                  <button
                    key={slot.kod}
                    type="button"
                    className={`time-slot-button ${active ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
                    onClick={() => handleSlotSelect(slot)}
                    disabled={disabled}
                  >
                    <span className="time-slot-label">{slot.label}</span>
                    <span className="time-slot-range">{slot.aralik || `${slot.baslangic}-${slot.bitis}`}</span>
                    <span className="time-slot-badge">
                      {count}/{max}
                    </span>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default DateAndTimeSelectStep;
